import { useSelector } from 'react-redux'
import LeftAlign from 'assets/svgr-icons/Left_Align.svg'
import CenterAlign from 'assets/svgr-icons/Center_Align.svg'
import RightAlign from 'assets/svgr-icons/Right_Align.svg'
import { IMediaControl } from './types'
import { T } from 'consts/translationKeys'
import { dispatch } from 'store'
import { projectDataThunks } from 'store/features/projectData/thunks'
import { selectActiveMedia } from 'store/selectors'
import { TTextAlign } from 'types/media'

export const useTextAlignControllers = (): IMediaControl[] => {
  const activeMedia = useSelector(selectActiveMedia)

  const handleAlign = (align: TTextAlign) => {
    if (!activeMedia?.meta.textData) return
    dispatch(
      projectDataThunks.updateMediaItem({
        id: activeMedia.id,
        updates: {
          meta: {
            ...activeMedia.meta,
            textData: { ...activeMedia.meta.textData, textAlign: align }
          }
        }
      })
    )
  }

  return [
    {
      id: 'left-align',
      tooltipText: T.TEXT_ALIGN_LEFT_LABEL,
      icon: <LeftAlign />,
      onClick: () => handleAlign('left'),
      isActive: activeMedia?.meta.textData?.textAlign === 'left'
    },
    {
      id: 'center-align',
      tooltipText: T.TEXT_ALIGN_CENTER_LABEL,
      icon: <CenterAlign />,
      onClick: () => handleAlign('center'),
      isActive: activeMedia?.meta.textData?.textAlign === 'center'
    },
    {
      id: 'right-align',
      tooltipText: T.TEXT_ALIGN_RIGHT_LABEL,
      icon: <RightAlign />,
      onClick: () => handleAlign('right'),
      isActive: activeMedia?.meta.textData?.textAlign === 'right'
    }
  ]
}
